export type Environment = {
  name: "localhost" | "dev" | "prod";
  REACT_APP_CONSUMER_KEY: string;
  REACT_APP_USERS_GRP_ID: string;
  REACT_APP_ADMINS_GRP_ID: string;
  REACT_APP_SUPERADMINS_GRP_ID: string;
  REACT_APP_BASE_URL: string;
};

function getRuntimeBaseUrl(): string {
  const baseUrl = globalThis.envVars?.REACT_APP_BASE_URL;

  if (!baseUrl) {
    throw new Error("Missing REACT_APP_BASE_URL in runtime envVars");
  }

  return baseUrl;
}

function getRuntimeConsumerKey(): string {
  const consumerKey = globalThis.envVars?.REACT_APP_CONSUMER_KEY;

  if (!consumerKey) {
    throw new Error("Missing REACT_APP_CONSUMER_KEY in runtime envVars");
  }

  return consumerKey;
}

export const environments: { [key in Environment["name"]]: Environment } = {
  localhost: {
    name: "localhost",
    REACT_APP_CONSUMER_KEY: process.env.REACT_APP_CONSUMER_KEY ?? '',

    REACT_APP_USERS_GRP_ID: "6598b311-6e92-4650-af00-3de68240e1ea",
    REACT_APP_ADMINS_GRP_ID: "ba571bfc-7865-4d1f-ac24-f34f23e98358",
    REACT_APP_SUPERADMINS_GRP_ID: "0d794e44-5bfd-4b77-af45-1c9061559e03",
    REACT_APP_BASE_URL: "https://localhost:7057/api",
  },
  dev: {
    name: "dev",
    REACT_APP_CONSUMER_KEY: getRuntimeConsumerKey(),

    REACT_APP_USERS_GRP_ID: "6598b311-6e92-4650-af00-3de68240e1ea",
    REACT_APP_ADMINS_GRP_ID: "ba571bfc-7865-4d1f-ac24-f34f23e98358",
    REACT_APP_SUPERADMINS_GRP_ID: "0d794e44-5bfd-4b77-af45-1c9061559e03",
    REACT_APP_BASE_URL: getRuntimeBaseUrl(),
  },
  prod: {
    name: "prod",
    REACT_APP_CONSUMER_KEY: getRuntimeConsumerKey(),

    REACT_APP_USERS_GRP_ID: "6598b311-6e92-4650-af00-3de68240e1ea",
    REACT_APP_ADMINS_GRP_ID: "ba571bfc-7865-4d1f-ac24-f34f23e98358",
    REACT_APP_SUPERADMINS_GRP_ID: "0d794e44-5bfd-4b77-af45-1c9061559e03",
    REACT_APP_BASE_URL: "https://api.maersk.com/apmmrebateportal/api",
  },
};

export function getCurrentEnvironment(): Environment {
  if (window.location.hostname === "apmmrebate.maersk.com" || window.location.hostname === "apmmrebateportal-ui.westeurope.prod.maersk.io") {
    return environments["prod"];
  }else if (
    window.location.hostname === "apmmrebateportal-ui.westeurope.dev.maersk.io" ||
    window.location.hostname === "apmmrebateportal-ui-cdt.maersk.io"
  ) {
    return environments["dev"];
  } else {
    return environments["localhost"];
  }
}
